import { useTypedQuery } from "hooks";
import { FactoryExportsDashboardQueryKeys } from "modules/FactoryExportsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { FactoryExportID } from "models";

type UseListReceiversQueryProps = {
  factory_export_id: FactoryExportID | null;
};

export const useReceiversQuery = ({ factory_export_id }: UseListReceiversQueryProps) =>
  useTypedQuery({
    queryKey: FactoryExportsDashboardQueryKeys.receivers,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { factory_export_id }, baseUrl)).data.receivers,
    enabled: false,
    refetchOnDependencies: [factory_export_id]
  });
